export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Obra',
  type: 'work',
  sections: {
    top: [
      {
        id: 'text-viewer',
        type: 'text-viewer',
        options: {
          enableClickOnEntities: true,
          toggleColumn: false,
          facsimileOptions: {
            showHomeControl: true,
            showFullPageControl: true,
            showNavigator: false,
          }
        },
      },
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'image-viewer',
        type: 'viewer',
        grid: 3,
        title: 'resource#image-viewer',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata'
      },
    ]
  }
};
